import { render, staticRenderFns } from "./chateau-la-mission-haut-brion.vue?vue&type=template&id=423a2fc9&scoped=true"
import script from "./chateau-la-mission-haut-brion.vue?vue&type=script&lang=js"
export * from "./chateau-la-mission-haut-brion.vue?vue&type=script&lang=js"
import style0 from "./chateau-la-mission-haut-brion.vue?vue&type=style&index=0&id=423a2fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a2fc9",
  null
  
)

export default component.exports